import { MessagePreviewLotteryProps } from "../types"
import React from "react"
import PreviewWrap from "./preview-wrap"
import PreviewText from "./preview-text"

const MessageLottery: React.FC<MessagePreviewLotteryProps> = ({ forwardPrependMsg }) => {
  return (
    <PreviewWrap>
      <PreviewText numberOfLines={1}>{`${forwardPrependMsg}[开奖]`}</PreviewText>
    </PreviewWrap>
  )
}
export default MessageLottery
